import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthTokenService } from '../../../../services/auth-token.service';
import { defaultErrorHandler } from '../../../../services/backend-caller.service';
import { ServicesService } from '../../../../services/services.service';
import { ViolationsService } from '../../../../services/violations.service';
import {DynamicConfigProviderService} from '../../../../services/dynamic-config-provider.service';

@Component({
  selector: 's-ori-user',
  templateUrl: './ori-user.component.html',
  styleUrls: ['./ori-user.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ORIUserComponent {

  @Input()
  public userName: string;

  @Input()
  public userPosition: string;

  @Input()
  public userAvatar: string;

  constructor(
    private authTokenService: AuthTokenService,
    private services: ServicesService,
    private violations: ViolationsService,
    private router: Router,
    public config: DynamicConfigProviderService,
  ) {
  }

  public logout() {
    this.authTokenService.logout()
      .pipe(defaultErrorHandler('Не удалось выйти из системы'))
      .subscribe(_ => {
        this.router.navigate(['login']);
      });
  }

  public refreshDb() {
    Swal.fire({
      title: 'Вы уверены, что хотите удалить все нарушения?',
      showConfirmButton: true,
      showCancelButton: true,
      showCloseButton: true,
      type: 'question',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет'
    }).then(res => {
      if (res.dismiss) {
        return;
      }

      this.services.refreshDatabase()
        .pipe(defaultErrorHandler('Не удалось очистить изменения в БД.'))
        .subscribe(value => {
          if (value) {
            Swal.fire({
              title: 'Очистка изменений',
              text: 'Очистка изменений БД прошла успешно.',
              type: 'success'
            }).then(_ => {
              this.violations.makeTotalRefreshRequest();
            });
          }
        });
    });
  }
}
